module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_0.c0d7499f.png";